import { Box, Chip, useTheme } from '@mui/material';
import type { FC, ReactElement } from 'react';

export type FieldChip = {
  label: string;
  borderColor?: string;
  textColor?: string;
};

type Props = {
  field: ReactElement;
  showChip: boolean;
  label: string;
  chipBorderColor?: string;
  chipTextColor?: string;
  extraChips?: FieldChip[];
};

export const FieldWithCustomChip: FC<Props> = ({
  field,
  showChip,
  label,
  chipBorderColor,
  chipTextColor,
  extraChips = [],
}) => {
  const theme = useTheme();

  const chips: FieldChip[] = [
    ...(showChip ? [{ label, borderColor: chipBorderColor, textColor: chipTextColor }] : []),
    ...extraChips,
  ];

  return (
    <Box
      sx={{
        flex: 1,
        position: 'relative',
      }}
    >
      {field}
      {chips.length > 0 && (
        <Box
          sx={{
            position: 'absolute',
            right: 20,
            top: 0,
            transform: 'translateY(-50%)',
            display: 'flex',
            gap: 0.5,
            maxWidth: 'calc(100% - 120px)',
          }}
        >
          {chips.map((chip) => (
            <Chip
              key={chip.label}
              label={chip.label}
              color='primary'
              size='small'
              variant='outlined'
              sx={{
                backgroundColor: 'white',
                border: `1px solid ${chip.borderColor ?? theme.palette.SlabGray['400']}`,
                color: chip.textColor ?? theme.palette.text.secondary,
                borderRadius: '8px',
                maxWidth: '100%',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
